// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__10dMo","notes":"Notes_notes__1YJ0m"};